let alertItems = {
    success: {
        save: "Success, Your data was saved",
        submit: "The form has been submitted successfully",
        edit: "Edited successfully",
        addUser: "User Account Created successfully",
        editUser: "the User's information Edited successfully",
        delete: "The item has been deleted successfully",
        deleteUser: "The User has been deleted successfully",
        login: "Welcome to BASF Application ...",
        register: "Congratulations, your account has been created",
        changeStatus: "The status successfully changed",
        changeAvatar: "Your profile image was updated",
        editProfile: "Your profile has been updated",
        changePassword: "Success, Your password has been changed",
        resetPassword: "Success, the password has been Reset",
        forgotPassword: "Your Password has been Reset and Sent to Your Email Address",
        upload: "Your File has been Uploaded",
        generateCode: "the OTP Code has been Generated",
        closeMessage: "your Message has been Closed",
        addOrder: "your Order have been submitted",
    },
    error: {
        access: "Sorry, you don't have access",
        notFound: "The data was not found",
        server: "Could not connect to server",
        emptyFields: "please fill the required items",
        rePassword: "the password repeat does not match with password",
        delete: "you can not delete this item",
    },
};

export default alertItems;
